module.exports = __webpack_public_path__ + "static/media/image.05d25028.svg";